import { render, staticRenderFns } from "./Interstitial.vue?vue&type=template&id=4c646892&scoped=true&"
import script from "./Interstitial.vue?vue&type=script&lang=js&"
export * from "./Interstitial.vue?vue&type=script&lang=js&"
import style0 from "./Interstitial.vue?vue&type=style&index=0&id=4c646892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c646892",
  null
  
)

export default component.exports